<div class="page-container">
  <div class="page-title">
    <span class="font-medium-display-medium"> Gutschein kaufen </span>
  </div>
  <div class="main-content padding-48-0">
    @if (isLoading) {
      @for (item of [].constructor(4); track $index) {
        <p-skeleton width="100%" height="128px"></p-skeleton>
      }
    } @else {
      @for (coupon of coupons; track $index) {
        <app-coupon [coupon]="coupon"></app-coupon>
      }
    }
  </div>
</div>
